"use client";
import { cn } from "@workspace/frontend-ui";
import { useEffect, useRef, useState } from "react";

type Props = {
  src: string;
  name: string;
  colorScheme: ColorScheme;
};

const ProviderTileLogo: FC<Props> = ({ src, name, colorScheme }) => {
  const [hasFailed, setHasFailed] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  const handleError = () => {
    setHasFailed(true);
  };

  useEffect(() => {
    if (imgRef.current?.complete && imgRef.current.naturalWidth === 0) {
      handleError();
    }
  }, []);

  if (!src || hasFailed) {
    return (
      <span
        data-testid="provider-logo-fallback"
        className="line-clamp-2 text-center font-medium text-foreground text-sm/6"
      >
        {name}
      </span>
    );
  }

  return (
    <img
      ref={imgRef}
      src={src}
      alt={name}
      data-testid="provider-logo"
      className={cn(
        "max-h-16 w-auto object-contain",
        colorScheme === "dark" && "invert",
      )}
      onError={handleError}
    />
  );
};

export default ProviderTileLogo;
